/**
 * @enum GameModuleStatus - Represents current status of game feature.
 */
export enum GameModuleStatus
{
    /**
     * @member Disabled - The game feature is disabled.
     */
    Disabled = <any>'disabled',

        /**
         * @member Enabled - The game feature is available to play.
         */
    Enabled = <any>'enabled',

        /**
         * @member Active - The game feature is in progress.
         */
    Active = <any>'active'
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/GameModuleStatus.ts
 **/